// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"95dbe7af","453":"37c81d69"}[chunkId] + ".chunk.js";
};